module.exports = __webpack_public_path__ + "img/ic-expand-panel.58275163.svg";